module.exports = __webpack_public_path__ + "img/534.7a770398.jpg";